import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { searchDebounce } from '../../utils/search-debounce-rxjs';
import { RegisterOptions } from '../models/register-options';
import { RegisterView } from '../models/register-view';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-compact-register-view',
    styleUrls: ['./compact-register-view.component.scss'],
    templateUrl: './compact-register-view.component.html',
    standalone: false
})
export class CompactRegisterViewComponent<
      TRegisterOptions extends RegisterOptions,
      TOrderingOptions extends OrderingOption
   >
   extends RegisterView<TRegisterOptions, TOrderingOptions>
   implements OnInit, OnDestroy
{
   hasSearchInput = false;

   searchText: string | null;

   private destroyed$ = new Subject<void>();

   private searchTextChange = new Subject<string>();

   constructor(store: Store) {
      super(store);
   }

   ngOnInit(): void {
      this.searchTextChange.pipe(searchDebounce(), distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe(() => {
         this.emitQuickFilterChange();
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onSearchTextChange(searchText: string): void {
      this.searchText = searchText.replace(/\\/g, '');
      this.searchTextChange.next(searchText);
   }

   private emitQuickFilterChange(): void {
      this.registerOptions = { ...this.registerOptions, searchText: this.searchText };
      this.quickFilterChange.emit(this.registerOptions);
   }
}
